/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-vars */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/prop-types */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable class-methods-use-this */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable no-underscore-dangle */
import React, { useState, useEffect } from 'react';
import { Container, Col, Row } from 'reactstrap';
import {
  Button,
} from '@material-ui/core';

import { connect } from 'react-redux';
import 'react-day-picker/lib/style.css';

import { useTranslation } from 'react-i18next';
import { reduxForm } from 'redux-form';
import { withStyles } from '@material-ui/core/styles';

import { Loading } from '../../../../helpers/utils';

import CourseInformations from '../../../../shared/components/CoursePlans/CourseInformations';
import LevelTable from '../../../../shared/components/CoursePlans/LevelTable';
import StudentScores from '../../../../shared/components/CoursePlans/StudentScores';
import CourseContent from './components/CourseContent';
import CourseObjectivesAndRessources from '../../../../shared/components/CoursePlans/CourseObjectivesAndRessources';
import { generatePDF } from '../../../Exports/components/EWExports/generateCoursePlan';

const styles = {
  root: {
    padding: 10,
    margin: 10,
  },
};

const CoursePlan = ({ courseInfos, user }) => {
  const [courseplan, setCourseplan] = useState(courseInfos.coursePlan);
  const [contentTitles, setContentTitles] = useState([]);
  const [specificSkills, setSpecificSkills] = useState(courseInfos.coursePlan.specificSkills);
  const [student, setStudent] = useState();
  const [loading, setLoading] = useState(true);
  const { i18n, t } = useTranslation();

  useEffect(() => {
    setLoading(true);
    if (courseInfos !== undefined && courseInfos.coursePlan.formationContent !== undefined) {
      const arr = [];
      let filteredContentTitles = [];
      courseInfos.coursePlan.formationContent.forEach((item) => {
        arr.push(...item.skillTitle);
      });
      const ids = arr.map((item) => item._id);
      filteredContentTitles = arr.filter(({ _id }, index) => !ids.includes(_id, index + 1));
      setContentTitles(filteredContentTitles);
    }
  }, [courseInfos, i18n.language]);

  useEffect(() => {
    if (contentTitles !== undefined && courseInfos !== undefined) {
      contentTitles.forEach((contentTitle) => {
        const formatedContent = [];
        contentTitle.skills.forEach((contentId) => {
          courseInfos.coursePlan.formationContent.forEach((contentObj) => {
            if (contentId === contentObj._id) {
              formatedContent.push(contentObj);
            }
          });
        });
        contentTitle.content = formatedContent;
      });
    }
    setLoading(false);
  }, [contentTitles]);

  useEffect(() => {
    courseInfos.listIdUsers.forEach((userItem) => {
      if (userItem._id === user._id) {
        setStudent(userItem);
      }
    });
  }, []);

  return (
    <div>
      {(courseplan !== undefined && courseInfos !== undefined)
        ? (
          <Container>
            <Col>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                }}
              >
                <h3>Plan de formation</h3>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => generatePDF(
                    courseInfos,
                    contentTitles,
                    specificSkills,
                    student,
                    t,
                    i18n.language,
                  )}
                  disableElevation
                  style={{
                    marginTop: '15px',
                  }}
                >
                  Télécharger
                </Button>
              </div>
              <CourseInformations courseInfos={courseInfos} />
              <LevelTable />
              {student
              && (
              <StudentScores
                students={[student]}
                courseInfos={courseInfos}
              />
              )}
              <CourseObjectivesAndRessources courseInfos={courseInfos} />
              {loading === false ? (
                <CourseContent
                  contentTitles={contentTitles}
                  middleTest={courseInfos.coursePlan.middleTest}
                  endTest={courseInfos.coursePlan.endTest}
                  courseInfos={courseInfos}
                  specificSkills={specificSkills}
                />
              )
                : <Loading />}
            </Col>
          </Container>
        )
        : <Loading />}
    </div>
  );
};

const CoursePlanTwo = withStyles(styles, { name: 'CoursePlan' })(CoursePlan);

function mapStateToProps(state) {
  const name = `group_${state.group.selectedGroup._id}`;
  const { user } = state.user;
  const dataform = state.form[`group_${state.group.selectedGroup._id}`];
  return {
    initialValues: state.group.selectedGroup,
    form: name,
    dataform,
    user,
  };
}

const connectedGroupForm = reduxForm({
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: false,
})(CoursePlanTwo);

const NewconnectedGroupForm = connect(mapStateToProps, {})(connectedGroupForm);

export default NewconnectedGroupForm;
